















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Validation } from 'vuelidate';
import { getValidationMessages } from '@/lib/validation/validationMessages.ts';

import QuickHelp from '@/views/components/input/QuickHelp.vue';

@Component({
  components: {
    QuickHelp,
  },
})
export default class PxNumberInput extends Vue {
  @Prop() value!: number | null | undefined;

  @Prop() description!: string | null;

  @Prop() titleText!: string;

  @Prop() id!: string;

  @Prop() validation!: Validation;

  @Prop({ default: false }) disabled!: boolean;

  // @Prop({default: 12}) mainFieldColSize!: number;
  @Prop({ default: 'Enter Value' }) placeholder!: string;

  @Prop() quickHelpText!: string | null;

  @Prop() min!: number | null;

  @Prop() max!: number | null;

  @Prop() unit!: string | null;

  @Prop({ default: null }) appendHtml!: string | null;

  @Prop({ default: false }) isHorizontal!: boolean;

  @Prop({ default: 4 }) labelColsSm!: number;

  @Prop({ default: 4 }) labelColsMd!: number;

  @Prop({ default: 4 }) labelColsLg!: number;

  @Prop({ default: false }) minimal!: boolean;

  @Prop() prepend!: string | null;

  @Prop({ default: false }) noMargin!: boolean;

  @Prop({ default: false }) alignRight!: boolean;

  // Seems to be necessary to structure this way to capture proper 'this'
  get inputValue(): number | null | undefined {
    return Number(this.value);
  }

  set inputValue(v: number | null | undefined) {
    this.$emit('input', Number(v));
  }

  get isValid(): boolean | null {
    // Try to force non-numeric inputs that somehow slip through to be invalid
    // @ts-ignore: runtime check for a runtime issue, ignore compile typecheck
    // const isNumeric = /[+-]?[0-9]+(\.[0-9]+)?/.test(this.value);
    // console.log(this.value);

    if (this.validation && this.validation.$dirty) {
      return !this.validation.$error;
    }
    return null;
  }

  get align() {
    return this.alignRight ? 'right' : 'left';
  }

  get showInvalidFeedback() {
    return this.validationText !== null && this.validationText !== '';
  }

  get validationText(): string | null {
    // Show messages only when field is both invalid & dirty
    if (this.validation && this.validation.$anyError) {
      return getValidationMessages(this.validation);
    }
    return null;
  }

  blur() {
    this.setPageDirty();
    this.$emit('blur');
  }

  setPageDirty(): void {
    if (this.validation) {
      this.validation.$touch();
    } else {
      console.debug('No validation rules available:', this.id);
    }
  }
}

